import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobEmailTemplate.List.IRequest;
type Response = Api.Core.ClaimJobEmailTemplate.List.IResponse;
type Headers = Api.Core.ClaimJobEmailTemplate.List.IHeaders;
const url = '/api/Management/ClaimJobEmailTemplate';
export default async function claimJobEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
